// extracted by mini-css-extract-plugin
module.exports = {"header":"SetConfigurationCalendars_header__3nWn8","headerBg":"SetConfigurationCalendars_headerBg__3b9rT","headerImg":"SetConfigurationCalendars_headerImg__2Cj0g"};